import axios from "axios";
import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "core_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !url.includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      const p = window.location.pathname;
      const pub = p === "/" || ["/login", "/case-history", "/area-clienti", "/privacy", "/portale", "/password-dimenticata", "/reimposta-password"].some((x) => p.startsWith(x));
      if (!pub) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Si è verificato un errore. Riprova.") {
  const detail = e?.response?.data?.detail;
  if (e?.response?.status === 413 && !detail) return "Il file supera la dimensione massima di 25 MB";
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ") || fallback;
  return detail.msg || fallback;
}

export const STATI = [
  { value: "da_fare", label: "Da fare" },
  { value: "in_corso", label: "In corso" },
  { value: "completata", label: "Completata" },
];
export const PRIORITA = [
  { value: "bassa", label: "Bassa" },
  { value: "media", label: "Media" },
  { value: "alta", label: "Alta" },
];
export const statoLabel = (v) => STATI.find((s) => s.value === v)?.label || v;
export const prioLabel = (v) => PRIORITA.find((s) => s.value === v)?.label || v;

export const fmtDate = (s) => (s ? format(parseISO(s), "d MMM yyyy", { locale: it }) : "—");
export const fmtDateTime = (s) => (s ? format(new Date(s), "d MMM yyyy, HH:mm", { locale: it }) : "—");

export function fmtBytes(n) {
  if (!n) return "0 B";
  const u = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(n) / Math.log(1024)), 3);
  return `${(n / 1024 ** i).toFixed(i ? 1 : 0).replace(".", ",")} ${u[i]}`;
}

export const initials = (nome = "", cognome = "") => `${nome[0] || ""}${cognome[0] || ""}`.toUpperCase();

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
}
